import { AnalyseConstants } from '../../../_constants';

const initialState = { saveTeamDetailsLoading: true, data: '', error: false };

export function saveTeamDetailsReducer(state = initialState, action) {
    switch (action.type) {
        case AnalyseConstants.REQUEST_SAVE_TEAM_DETAIL:
            return {
                saveTeamDetailsLoading: false,
                data: state.data,
                error: false
            };
        case AnalyseConstants.RECEIVE_SAVE_TEAM_DETAIL:
            return {
                saveTeamDetailsLoading: false,
                data: action.data,
                error: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/saveTeam/saveTeam.reducer.js